import isNil from 'lodash/isNil';

export const pluralize = (word: string, count: number, inclusive?: boolean) => {
  if (isNil(word) || isNil(count) || count < 0) {
    return '—';
  }

  return inclusive ? (count === 1 ? `${count} ${word}` : `${count} ${word}s`) : count === 1 ? word : `${word}s`;
};

export const capitalizeFirstLetter = (str: string) => {
  return str[0].toUpperCase() + str.slice(1);
};
